import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'formik';
import { getOptions } from '@ourbranch/lookups';

import Grid from '@material-ui/core/Grid';
import { LabelTooltip } from 'core/components/label-tooltip';
import { tooltipHoverTexts } from 'core/helpers/constants';
import { FormField } from '../../../../../core/components/form';

const KansasAutoLimits = ({ id, disabled, UMBIOptions }) => {
  return (
    <>
      <Grid item xs={6}>
        <LabelTooltip
          label="Un/Underinsured Motorist BI"
          tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.umUimBodilyInjury }}
        >
          <FormField
            mode="dark"
            name={`${id}.policyLimitUMBI`}
            id={`${id}.policyLimitUMBI`}
            type="select"
            options={UMBIOptions}
            optional
            disabled={disabled}
            fast={false}
          />
        </LabelTooltip>
      </Grid>

      <Grid item xs={6}>
        <LabelTooltip
          label="Personal Injury Protection"
          tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.personalInjuryProtection }}
        >
          <FormField
            mode="dark"
            name={`${id}.policyLimitPIP`}
            id={`${id}.policyLimitPIP`}
            type="select"
            options={getOptions('policyLimitPIP', 'KS')}
            optional
            disabled={disabled}
          />
        </LabelTooltip>
      </Grid>
    </>
  );
};

KansasAutoLimits.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  UMBIOptions: PropTypes.array.isRequired
};

KansasAutoLimits.defaultProps = {
  disabled: false
};

export default connect(KansasAutoLimits);
